import React, { useContext } from "react";
import { string, func } from "prop-types";
import { ServiceRequestContext } from "context/ServiceRequestContext";
import { Utils } from "services/utils";
import styled from "styled-components";
import format from "date-fns/format";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;
const EditIconHover = `${CDN_URL}common/icons-edit-selected-lg.svg`;

const ReviewStyle = styled.div`
  width: 100%;
  height: 200px;
  margin-bottom: 50px;

  .ScrollbarsCustom-Track {
    right: -15px !important;
    top: 0px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.support} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
    max-height: 150px;
  }
  .section-details-wrapper {
    display: flex;
    margin-bottom: 10px;
    .user-details,
    .dc-locations-details,
    .badge-details {
      width: 100%;
    }
    .section-details {
      width: 90%;
      margin-bottom: 20px;
    }

    .dc-locations-details {
      width: 100%;
      margin-bottom: 20px;
    }
    .detail-row {
      display: flex;
      justify-content: flex-start;
      height: 20px;
      margin-bottom: 10px;
      .label {
        margin-top: 4px;
        width: 60px;
      }
      .value {
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10px;
        display: flex;
        .location {
          margin-right: 5px;
        }
      }
    }
    .edit-icon {
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
      }
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 230px;
    margin-bottom: 50px;
    .ScrollbarsCustom-Track {
      right: -15px !important;
      top: 0px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 8px !important;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 8px !important;
      max-height: 450px;
    }

    .section-details-wrapper {
      margin-bottom: 10px;

      .section-details {
        width: 90%;
        margin-bottom: 20px;
      }

      .dc-locations-details {
        margin-bottom: 20px;
      }
      .detail-row {
        height: 20px;
        margin-bottom: 10px;
        .label {
          margin-top: 0px;
          width: 80px;
        }
        .value {
          width: 275px;
          margin-left: 10px;
          display: flex;
          .location {
            margin-right: 5px;
          }
        }
      }
      .edit-icon {
        img {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 400px;
    margin-bottom: 50px;
    .ScrollbarsCustom-Track {
      right: -15px !important;
      top: 0px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 10px !important;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 10px !important;
      max-height: 450px;
    }
    .section-details-wrapper {
      margin-bottom: 10px;

      .section-details {
        width: 90%;
        margin-bottom: 30px;
      }

      .dc-locations-details {
        margin-bottom: 30px;
      }
      .detail-row {
        height: 20px;
        margin-bottom: 15px;
        .label {
          width: 120px;
        }
        .value {
          width: 400px;
          margin-top: 8px;
          height: 40px;
          margin-left: 10px;
          display: flex;
          .location {
            margin-right: 5px;
          }
        }
      }
      .edit-icon {
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
  }
`;

function getEditIcon(activePage, setActivePageIndex) {
  return (
    <div className="edit-icon">
      <img
        src={EditIconDefault}
        onMouseOver={(e) => {
          e.currentTarget.src = EditIconHover;
        }}
        onMouseOut={(e) => {
          e.currentTarget.src = EditIconDefault;
        }}
        alt="edit-icon"
        onClick={() => setActivePageIndex(activePage)}
      />
    </div>
  );
}

export const ReviewScreen = ({ setActivePageIndex, type }) => {
  const { inputs } = useContext(ServiceRequestContext);

  const isValidStartDate =
    inputs?.startDateTime && !isNaN(new Date(inputs.startDateTime));
  const isValidEndDate =
    inputs?.endDateTime && !isNaN(new Date(inputs.endDateTime));

  const startDate = isValidStartDate
    ? format(new Date(inputs.startDateTime), "MMM d, yyyy hh:mm a")
    : "Not set";
  const endDate = isValidEndDate
    ? format(new Date(inputs.endDateTime), "MMM d, yyyy hh:mm a")
    : "Not set";

  const ila = inputs?.type === "ila" ? true : false;
  const attendees = inputs?.attendees;

  function getTimezone(location) {
    let timezone = "";
    if (
      location === "CHA" ||
      location === "ATL" ||
      location === "GSP" ||
      location === "MYR"
    ) {
      timezone = "Eastern Standard Time";
    } else if (location === "HSV" || location === "BHM") {
      timezone = "Central Standard Time";
    } else {
      timezone = "Eastern Standard Time";
    }
    return timezone;
  }

  return (
    <ReviewStyle>
      <ScrollView>
        <div className="section-details-wrapper">
          <div className="section-details">
            <div className="detail-row">
              <div className="label labels21">Location:</div>
              <div className="value body10">{inputs.location}</div>
            </div>
            <div className="detail-row">
              <div className="label labels21">Time Zone:</div>
              <div className="value body10">{getTimezone(inputs.location)}</div>
            </div>
          </div>
        </div>
        <div className="section-details-wrapper">
          <div className="section-details">
            <div className="detail-row">
              <div className="label labels21">Description:</div>
              <div className="value body10">{inputs.description}</div>
            </div>
            {ila && (
              <div className="detail-row">
                <div className="label labels21">Clearance :</div>
                <div className="value body10">
                  {Utils.getClearanceLevel(inputs?.clearance)}
                </div>
              </div>
            )}
            <div className="detail-row">
              <div className="label labels21">Title:</div>
              <div className="value body10">{inputs.title}</div>
            </div>
          </div>
          {type !== "REMOTE_HANDS"
            ? getEditIcon(1, setActivePageIndex)
            : getEditIcon(0, setActivePageIndex)}
        </div>

        {type !== "REMOTE_HANDS" && !ila && (
          <div className="section-details-wrapper">
            <div className="section-details">
              <div className="detail-row">
                <div className="label labels21">POD :</div>
                <div className="value body10">{inputs.podNumber}</div>
              </div>
              <div className="detail-row">
                <div className="label labels21">Cabinet ID:</div>
                <div className="value body10">{inputs.cabNumber}</div>
              </div>
            </div>
            {getEditIcon(3, setActivePageIndex)}
          </div>
        )}
        {ila && (
          <div className="section-details-wrapper">
            <div className="section-details">
              <div className="detail-row">
                <div className="label labels21">Priority :</div>
                <div className="value body10">{inputs?.priority}</div>
              </div>
            </div>
            {getEditIcon(3, setActivePageIndex)}
          </div>
        )}
        <div className="section-details-wrapper">
          <div className="section-details">
            <div className="detail-row">
              <div className="label labels21">Name:</div>
              <div className="value body10">{inputs.name}</div>
            </div>
            <div className="detail-row">
              <div className="label labels21">Email:</div>
              <div className="value body10">{inputs.email}</div>
            </div>
            <div className="detail-row">
              <div className="label labels21">Phone:</div>
              <div className="value body10">{inputs.phone}</div>
            </div>
          </div>
          {type !== "REMOTE_HANDS"
            ? getEditIcon(4, setActivePageIndex)
            : getEditIcon(3, setActivePageIndex)}
        </div>
        {ila && attendees && attendees?.length !== 0 && (
          <div className="section-details-wrapper">
            <div className="section-details">
              <div className="detail-row">
                <div className="label labels21">Attendees :</div>
                <div className="value body10">
                  {attendees.map((attendee) => (
                    <div className="attendee">{` ${attendee} `}&nbsp;</div>
                  ))}
                </div>
              </div>
            </div>
            {getEditIcon(4, setActivePageIndex)}
          </div>
        )}
        <div className="section-details-wrapper">
          <div className="section-details">
            <div className="detail-row">
              <div className="label labels21">Start Date:</div>
              <div className="value body10">{startDate}</div>
            </div>
            <div className="detail-row">
              <div className="label labels21">End Date:</div>
              <div className="value body10">{endDate}</div>
            </div>
          </div>
          {type === "REMOTE_HANDS"
            ? getEditIcon(2, setActivePageIndex)
            : getEditIcon(5, setActivePageIndex)}
        </div>
      </ScrollView>
    </ReviewStyle>
  );
};

ReviewScreen.propTypes = {
  setActivePageIndex: func.isRequired,
  type: string,
};

ReviewScreen.defaultProps = {
  type: "",
};
